import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import InvoiceColumn from "Common/Components/ColumnData/InvoiceColumn";
import { SearchIcon, X } from "lucide-react";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import Swal from "sweetalert2";
import InvoiceWithInput from "Common/Components/PDFRender";

const InvoiceFarmer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [reload, setReload] = useState<number>(0); // ← تغییر از boolean به number
  const [data, setData] = useState<any[]>([]); // ← مقدار پیش‌فرض آرایه خالی
  const [totalItems, setTotalItems] = useState(0);
  const [allData, setAllData] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setSize] = useState<number>(1);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [exportPdf, setExportPdf] = useState<any>(false);
  const cropYearID = localStorage.getItem("crop_year_id");
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const [loadingModalPDF, setloadingModalPDF] = useState<any>(false);
  const [userinfoAllData, setuserinfoAllData] = useState<any>(false);
  const [total_farmers_receivable, settotal_farmers_receivable] = useState<any>();
  const [sortState, setSortState] = useState<any>({
    name: "remaining_receivable_payable_balance",
    order: "desc",
    step: 0,
  });
  const sortLabels: any = {
    farmer_name: "کشاورز",
    remaining_receivable_payable_balance: "مانده طلب / بدهی",
    total_farmers_price: "جمع پرداخت‌ها",
    total_seed_cost: "بدهی بذر",
    total_weight: "وزن کل بار ها",
    total_guarantee_price: "بدهی ضمانت",
    total_pesticide_cost: "بدهی سم",
    pure_payable: "مبلغ کل بار ها",
    newest_date: " تاریخاخرین بار تحویلی ",
  };
  const [total_delivered_beet_weight, settotal_delivered_beet_weight] = useState<any>();
  const [total_load_price, settotal_load_price] = useState<any>();
  const [DataSeed, setDataSeed] = useState<any>([]);
  const [Dataesticide, setDataesticide] = useState<any>([]);
  const [LoadFarmer, setLoadFarmer] = useState<any>([]);
  const [pamentFarmerr, setpamentFarmerr] = useState<any>([]);
  const [reportData, setReportData] = useState<any>([]);
  const [UserFullName, setUserFullName] = useState<boolean>(true);
  // نام پیمانکارِ کشاورزی که صورتحساب او در حال گرفتن خروجی PDF است
  const [contractorName, setContractorName] = useState<string>("");

  // ✅ Ref برای جلوگیری از race condition
  const searchQueryRef = useRef(searchQuery);
  const requestIdRef = useRef(0);

  // ✅ Ref را همیشه همگام با state نگه می‌داریم
  useEffect(() => {
    searchQueryRef.current = searchQuery;
  }, [searchQuery]);

  const normalizeSearch = (text: string) => {
    if (!text) return "";
    return text
      .replace(/\u200c/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  useEffect(() => {
    const fetchYear = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == cropYearID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    fetchYear();
  }, []);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // ✅ کنسل کردن درخواست قبلی با AbortController
  const fetchData = async (page: number, size: number) => {
    // فقط تازه‌ترین درخواست اجازه نوشتن در state را دارد
    const requestId = ++requestIdRef.current;

    setIsLoading(true);
    setData([]); // پاک کردن داده قبلی

    const token = localStorage.getItem("app_atkey");

    try {
      const cropID = Number(localStorage.getItem("crop_year_id"));
      let url = `https://api.havirkesht.ir/farmers_invoice/?page=${page}&size=${size}&crop_year_id=${cropID}`;

      if (sortState.name) {
        if (sortState.step === 2) {
          url += `&sort_by=${sortState.name}&sort_order=desc`;
        } else {
          url += `&sort_by=${sortState.name}&sort_order=${sortState.order}`;
        }
      }

      const cleanedSearch = normalizeSearch(searchQueryRef.current);
      if (cleanedSearch) {
        url += `&search=${encodeURIComponent(cleanedSearch)}`;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // پاسخ یک درخواست قدیمی‌تر نباید روی نتیجه فعلی بنشیند
      if (requestId !== requestIdRef.current) {
        return;
      }

      setIsLoading(false);
      setData(response.data.items);
      setTotalItems(response?.data?.total);
      settotal_farmers_receivable(response?.data.total_farmers_receivable);
      settotal_delivered_beet_weight(response?.data?.total_delivered_beet_weight);
      settotal_load_price(response?.data?.total_load_price);
      setAllData(response?.data?.total);
      setTotalPages(response?.data?.pages);
    } catch (error: any) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      setIsLoading(false);
      console.error("خطا در دریافت داده‌ها:", error);
    }
  };

  // ==============================================================
  // ✅ استفاده از debounceSearch برای جلوگیری از درخواست‌های اضافی
  // ==============================================================
  const debounceSearchRef = useRef<NodeJS.Timeout | null>(null);

  // ==============================================================
  // ✅ یک useEffect واحد که همه dependencies را کنترل می‌کند
  // ==============================================================
  useEffect(() => {
    // ✅ Debounce: اگر سرچ تغییر کرده، صبر کن تا کاربر تایپ کردن تمام کند
    if (debounceSearchRef.current) {
      clearTimeout(debounceSearchRef.current);
    }

    debounceSearchRef.current = setTimeout(() => {
      setCurrentPage(1);
      fetchData(1, selectedNumber);
    }, 300);

    return () => {
      if (debounceSearchRef.current) {
        clearTimeout(debounceSearchRef.current);
      }
    };
  }, [searchQuery]);

  // ✅ این useEffect فقط برای page/size/sort/reload تغییرات
  // نباید searchQuery را داشته باشد چون باعث double-fetch می‌شود
  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, selectedNumber, sortState, reload]);

  // ==============================================================
  // ✅ حذف useEffect اضافی initialization
  // ==============================================================
  // ❌ حذف شد: useEffect(() => { setreload(!reload); }, []);
  // چون باعث re-render اضافی و race condition می‌شد

  const fetchReport = async (farmer_ID: any): Promise<void> => {
    const API_BASE_URL = "https://api.havirkesht.ir";
    const AUTH_TOKEN = localStorage.getItem("app_atkey");
    const headers = {
      Authorization: `Bearer ${AUTH_TOKEN}`,
    };

    try {
      const userResponse = await axios.get<any>(
        `${API_BASE_URL}/farmer/farmer-id-to-user-id/${farmer_ID}`
      );
      const userID = userResponse?.data?.user_id;

      const [
        seedResponse,
        commitmentResponse,
        pesticideResponse,
        loadResponse,
        paymentResponse,
        reportDataResponse,
        userinfoData,
      ] = await Promise.all([
        axios.get(
          `${API_BASE_URL}/farmers-seed/by-user/${userID}?crop_year_id=${cropYearID}`,
          { headers }
        ),
        axios.get<any[]>(
          `${API_BASE_URL}/commitment/by-user/${userID}?crop_year_id=${cropYearID}`,
          { headers }
        ),
        axios.get(
          `${API_BASE_URL}/farmers-pesticide/by-user/${userID}?crop_year_id=${cropYearID}`,
          { headers }
        ),
        axios.get(
          `${API_BASE_URL}/farmers_load/by-user/${userID}?crop_year_id=${cropYearID}`,
          { headers }
        ),
        axios.get(
          `${API_BASE_URL}/farmers_payment/by-user/${userID}?crop_year_id=${cropYearID}`,
          { headers }
        ),
        axios.get(
          `${API_BASE_URL}/users-dashboard/?crop_year_id=${cropYearID}&user_id=${userID}`,
          { headers }
        ),
        axios.get(`${API_BASE_URL}/users/${userID}`, { headers }),
      ]);

      setUserFullName(commitmentResponse.data[0]);
      setDataSeed(seedResponse.data);
      setDataesticide(pesticideResponse.data);
      setLoadFarmer(loadResponse.data);
      setpamentFarmerr(paymentResponse.data);
      setReportData(reportDataResponse.data);
      setuserinfoAllData(userinfoData.data);
      setExportPdf(true);
      setloadingModalPDF(false);
    } catch (err) {
      setloadingModalPDF(false);
      alert("خطا در دریافت اطلاعات صورتحساب کشاورز");
      console.error("Error fetching report:", err);
    }
  };

  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        const nextStep = (prev.step + 1) % 3;
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 };
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 };
        } else {
          return { name, order: "desc", step: 0 };
        }
      } else {
        return { name, order: "desc", step: 0 };
      }
    });
    setReload((prev) => prev + 1); // ✅ از عدد به‌جای boolean استفاده شود
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;

    const totalItems = allData ? Number(allData) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }
    setSize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید
    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(currentPage, selectedNumber);
  };
  const handlersettlement = async (data: any) => {
    const {
      one_percent_deduction = 0,
      pure_payable = 0,
      remaining_receivable_payable_balance = 0,
      total_farmers_price = 0,
      total_guarantee_price = 0,
      total_pesticide_cost = 0,
      total_seed_cost = 0,
      total_weight = 0,
      farmer_id,
    } = data;

    const allZero = [
      one_percent_deduction,
      pure_payable,
      remaining_receivable_payable_balance,
      total_farmers_price,
      total_guarantee_price,
      total_pesticide_cost,
      total_seed_cost,
      total_weight,
    ].every((value) => value === 0);

    if (allZero) {
      Swal.fire({
        title: "خطا",
        text: "هیچ موردی برای این کشاورز ثبت نشده است.",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    if (
      remaining_receivable_payable_balance < 0 ||
      total_guarantee_price < 0 ||
      total_weight <= 0
    ) {
      Swal.fire({
        title: "خطا",
        text: "به علت صفر نبودن مانده طلب یا بدهی ضمانت، امکان تسویه حساب وجود ندارد.",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }

    try {
      const result = await Swal.fire({
        title: "تأیید تسویه حساب",
        text: "آیا از تسویه حساب این کشاورز مطمئن هستید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
      });

      if (result.isConfirmed) {
        const yearID = localStorage.getItem("crop_year_id");
        const res = await axios.post(
          "https://api.havirkesht.ir/farmers_invoice/payment",
          { farmer_id: farmer_id, crop_year_id: yearID, payed: true },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );

        if (res.status === 200) {
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-invoice-notification/${farmer_id}/${yearID}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
              },
            }
          );
          Swal.fire({
            title: "موفقیت آمیز",
            text: "تسویه حساب با موفقیت انجام شد.",
            icon: "success",
            confirmButtonText: "متوجه شدم",
          });
          setReload((prev) => prev + 1);
          resetSorting();
        }
      }
    } catch (error: any) {
      console.error("Error in settlement:", error);
      Swal.fire({
        title: "خطا",
        text:
          error.response?.status === 400
            ? "درخواست نامعتبر (کد 400)"
            : "مشکلی در انجام تسویه حساب رخ داده است.",
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
  };

  // ردیف کامل کشاورز از /farmers_invoice/ دریافت می‌شود تا نام پیمانکار خودش در PDF ثبت شود
  const pdfRenderInvoice = async (row: any) => {
    const farmerID = typeof row === "object" ? row?.farmer_id : row;
    setContractorName(
      typeof row === "object" ? row?.contractor_name || "" : ""
    );
    setloadingModalPDF(true);
    fetchReport(farmerID);
  };

  const columns = InvoiceColumn({
    columnName,
    handlersettlement,
    pdfRenderInvoice,
  });

  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setReload((prev) => prev + 1);
  };

  if (loadingModalPDF)
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-xl flex flex-col items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
          <p className="text-gray-700">
            در حال آماده‌سازی فایل PDF، لطفاً صبر کنید...
          </p>
        </div>
      </div>
    );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="مدیریت پرداخت‌ها" title="پنل مدیریت" />
      <div className="card" id="paymentTable">
        <div className="card-body">
          <div className="flex flex-col md:flex-row gap-3 mb-4 items-center">
            <h6 className="text-15 grow md:text-right text-center">
              تعداد کل : <b>{totalItems}</b>
              <br />
              <span>{`سال زراعی انتخاب شده ${YearCoptSelect ? YearCoptSelect : ""}`}</span>
            </h6>
            <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
              <span className="whitespace-nowrap p-1">جستجو:</span>
              <div className="relative w-full sm:w-64">
                <input
                  type="text"
                  className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                  placeholder="جستجو..."
                  value={searchQuery || ""}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                  {searchQuery ? (
                    <X
                      size={15}
                      className="cursor-pointer"
                      onClick={() => setSearchQuery("")}
                    />
                  ) : (
                    <SearchIcon size={15} />
                  )}
                </span>
              </div>
              <div className="w-full sm:w-auto">
                <TableDropDownSmall onSelect={handleSelect} />
              </div>
            </label>
          </div>
          <div className="flex md:flex-row flex-col flex-wrap gap-4 p-4 dark:text-white">
            <div className="bg-white p-4 rounded-lg shadow dark:bg-gray-600 dark:text-white">
              <div className="text-gray-500 text-sm dark:text-white">جمع طلب کشاورز</div>
              <div className="text-red-500 rtl font-bold dark:text-white mt-1">
                {total_farmers_receivable?.toLocaleString("fa-IR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                })}
              </div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow dark:bg-gray-600 dark:text-white">
              <div className="text-gray-500 text-sm dark:text-white">وزن کل چغندر تحویلی</div>
              <div className="text-green-600 font-bold dark:text-white mt-1">
                {total_delivered_beet_weight?.toLocaleString("fa-IR")}
              </div>
            </div>
            <div className="bg-white p-4 rounded-lg shadow dark:bg-gray-600 dark:text-white">
              <div className="text-gray-500 text-sm dark:text-white">مبلغ کل بارها</div>
              <div className="text-blue-600 font-bold dark:text-white mt-1">
                {total_load_price?.toLocaleString("fa-IR", {
                  maximumFractionDigits: 0,
                  minimumFractionDigits: 0,
                })}
              </div>
            </div>
          </div>

          <div className=""></div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? "(تاریخ ایجاد)"
                : `${sortLabels[sortState.name]} ${sortState.order === "asc" ? "(صعودی)" : "(نزولی)"}`}
            </div>
          )}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              customnumberfortable={8}
              data={data}
              TableFarmerInvoise={true}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
            />
          ) : (
            <LoadingCounter
              count={isLoading ? 10 : 0}
              text={isLoading ? "در حال بارگذاری..." : "داده‌ای دریافت نشد"}
            />
          )}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <InvoiceWithInput
        dataSeed={DataSeed}
        userInfo={UserFullName}
        exportPdfFromProp={exportPdf}
        userinfoData={userinfoAllData}
        dataLoad={LoadFarmer}
        dataPayment={pamentFarmerr}
        dataPoison={Dataesticide}
        reportData={reportData}
        contractorName={contractorName}
        dontShowData={true}
      />
    </React.Fragment>
  );
};

export default InvoiceFarmer;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import BreadCrumb from "Common/BreadCrumb";
// import TableContainer from "Common/TableContainer";
// import LoadingCounter from "Common/Components/LoadingCounterProps";
// import InvoiceColumn from "Common/Components/ColumnData/InvoiceColumn";
// import { SearchIcon, X } from "lucide-react";
// import PaginationTest from "Common/Components/Paginationtest";
// import TableDropDownSmall from "pages/Components/TableDropDownSmall";
// import Swal from "sweetalert2";
// import InvoiceWithInput from "Common/Components/PDFRender";
// const InvoiceFarmer = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState<any>("");
//   const [reload, setreload] = useState<any>();
//   const [data, setdata] = useState<any[]>();
//   const [totalItems, setTotalItems] = useState(0);
//   const [alldata, setalldata] = useState<Number>();
//   const [currentPage, setCurrentPage] = useState<number>(1);
//   const [size, setsize] = useState<number>(1);
//   const [selectedNumber, setSelectedNumber] = useState<any>(10);
//   const [totalPages, setTotalPages] = useState<number>(0);
//   const [exportPdf, setExportPdf] = useState<any>(false);
//   const cropYearID = localStorage.getItem("crop_year_id");
//   const [YearCoptSelect, setYearCoptSelect] = useState<any>();
//   const [loadingModalPDF, setloadingModalPDF] = useState<any>(false);
//   const [userinfoAllData, setuserinfoAllData] = useState<any>(false);
//   const [total_farmers_receivable, settotal_farmers_receivable] =
//     useState<any>();
//   const [sortState, setSortState] = useState<any>({
//     name: "remaining_receivable_payable_balance",
//     order: "desc",
//     step: 0,
//   });
//   const sortLabels: any = {
//     farmer_name: "کشاورز",
//     remaining_receivable_payable_balance: "مانده طلب / بدهی",
//     total_farmers_price: "جمع پرداخت‌ها",
//     total_seed_cost: "بدهی بذر",
//     total_weight: "وزن کل بار ها",
//     total_guarantee_price: "بدهی ضمانت",
//     total_pesticide_cost: "بدهی سم",
//     pure_payable: "مبلغ کل بار ها",
//     newest_date: " تاریخ اخرین بار تحویلی ",
//   };

//   const [total_delivered_beet_weight, settotal_delivered_beet_weight] =
//     useState<any>();
//   const [total_load_price, settotal_load_price] = useState<any>();
//   const [DataSeed, setDataSeed] = useState<any>([]);
//   const [Dataesticide, setDataesticide] = useState<any>([]);
//   const [LoadFarmer, setLoadFarmer] = useState<any>([]);
//   const [pamentFarmerr, setpamentFarmerr] = useState<any>([]);
//   const [reportData, setReportData] = useState<any>([]);
//   const [UserFullName, setUserFullName] = useState<boolean>(true);
//   const normalizeSearch = (text: string) => {
//     if (!text) return "";

//     return text
//       .replace(/\u200c/g, " ") // نیم فاصله → فاصله
//       .replace(/\s+/g, " ") // چند فاصله → یک فاصله
//       .trim(); // حذف فاصله اول و آخر
//   };



//   useEffect(() => {
//     const featchData = async () => {
//       const response = await axios.get("https://api.havirkesht.ir/crop-year/");
//       const getyear = response?.data?.items?.find(
//         (items: any) => items.id == cropYearID
//       );
//       setYearCoptSelect(getyear?.crop_year_name);
//     };
//     featchData();
//   }, []);
//   const handlePageChange = (page: number) => {
//     setCurrentPage(page);
//   };

//   const fetchReport = async (farmer_ID: any): Promise<void> => {
//     // تعریف ثابت‌ها
//     const API_BASE_URL = "https://api.havirkesht.ir";
//     const AUTH_TOKEN = localStorage.getItem("app_atkey");

//     const headers = {
//       Authorization: `Bearer ${AUTH_TOKEN}`,
//     };

//     try {
//       // 1. دریافت userID
//       const userResponse = await axios.get<any>(
//         `${API_BASE_URL}/farmer/farmer-id-to-user-id/${farmer_ID}`
//       );
//       const userID = userResponse?.data?.user_id;

//       // 2. اجرای تمام درخواست‌ها به صورت موازی
//       const [
//         seedResponse,
//         commitmentResponse,
//         pesticideResponse,
//         loadResponse,
//         paymentResponse,
//         reportData,
//         userinfoData,
//       ] = await Promise.all([
//         axios.get(`${API_BASE_URL}/farmers-seed/by-user/${userID}`, {
//           headers,
//         }),
//         axios.get<any[]>(`${API_BASE_URL}/commitment/by-user/${userID}`, {
//           headers,
//         }),
//         axios.get(`${API_BASE_URL}/farmers-pesticide/by-user/${userID}`, {
//           headers,
//         }),
//         axios.get(`${API_BASE_URL}/farmers_load/by-user/${userID}`, {
//           headers,
//         }),
//         axios.get(`${API_BASE_URL}/farmers_payment/by-user/${userID}`, {
//           headers,
//         }),
//         axios.get(
//           `${API_BASE_URL}/users-dashboard/?crop_year_id=${cropYearID}&user_id=${userID}`,
//           {
//             headers,
//           }
//         ),
//         axios.get(`${API_BASE_URL}/users/${userID}`, {
//           headers,
//         }),
//       ]);

//       // 3. تنظیم state ها
//       setUserFullName(commitmentResponse.data[0]);
//       setDataSeed(seedResponse.data);
//       setDataesticide(pesticideResponse.data);
//       setLoadFarmer(loadResponse.data);
//       setpamentFarmerr(paymentResponse.data);
//       setReportData(reportData.data);
//       setuserinfoAllData(userinfoData.data);
//       setExportPdf(true);
//       setloadingModalPDF(false);
//       // setTimeout(() => {
//       //   setExportPdf(false);
//       //   setUserFullName(false);
//       //   setDataSeed([]);
//       //   setDataesticide([]);
//       //   setLoadFarmer([]);
//       //   setpamentFarmerr([]);
//       // }, 1000);
//     } catch (err) {
//       setloadingModalPDF(false);
//       alert(
//         "خطا در دریافت اطلاعات صورتحساب کشاورز اطلاعات این کشاورز در سیستم ثبت نشده است"
//       );
//       console.error("Error fetching report:", err);
//     }
//   };


//   // useEffect(() => {
//   //   fetchData(currentPage, selectedNumber);
//   // }, [currentPage, selectedNumber, searchQuery, reload, sortState]);
//   useEffect(() => {
//     fetchData(currentPage, selectedNumber);
//   }, [currentPage, selectedNumber, reload, sortState]);

//   useEffect(() => {
//     const delay = setTimeout(() => {
//       setCurrentPage(1);
//       fetchData(1, selectedNumber);
//     }, 300);

//     return () => clearTimeout(delay);
//   }, [searchQuery]);

//   const fetchData = async (page: number, size: number) => {
//     setIsLoading(true);
//     setdata([]);
//     const token = localStorage.getItem("app_atkey");
//     try {
//       const cropID = Number(localStorage.getItem("crop_year_id"));
//       let url = `https://api.havirkesht.ir/farmers_invoice/?page=${page}&size=${size}&crop_year_id=${cropID}`;

//       // حالت‌های مختلف مرتب‌سازی
//       if (sortState.name) {
//         if (sortState.step === 2) {
//           url += `&sort_by=${sortState.name}&sort_order=desc`;
//         } else {
//           url += `&sort_by=${sortState.name}&sort_order=${sortState.order}`;
//         }
//       }
//       // const trimmedSearch = searchQuery.trim();
//       // if (searchQuery && searchQuery.trim() !== "") {
//       //   url += `&search=${encodeURIComponent(searchQuery.trim())}`;
//       // }
//       const cleanedSearch = normalizeSearch(searchQuery);

//       if (cleanedSearch) {
//         // url += `&search=${encodeURIComponent(cleanedSearch)}`;
//          url += `&search=${encodeURIComponent(searchQuery.trim())}`;
//       }

//       // if (searchQuery) {
//       //   url += `&search=${encodeURIComponent(searchQuery)}`;
//       // }



//       const response = await axios.get(url, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setIsLoading(false);
//       setdata(response.data.items);
//       setTotalItems(response?.data?.total);
//       settotal_farmers_receivable(response?.data.total_farmers_receivable);
//       settotal_delivered_beet_weight(
//         response?.data?.total_delivered_beet_weight
//       );
//       settotal_load_price(response?.data?.total_load_price);
//       setalldata(response?.data?.total);
//       setTotalPages(response?.data?.pages);
//     } catch (error) {
//       setIsLoading(false);
//       console.error("خطا در دریافت داده‌ها:", error);
//     }
//   };

//   const columnName = (name: string) => {
//     setSortState((prev: any) => {
//       if (prev.name === name) {
//         // اگر روی همان ستون کلیک شد
//         const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
//         if (nextStep === 0) {
//           return { name, order: "desc", step: 0 }; // حالت اول: نزولی
//         } else if (nextStep === 1) {
//           return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
//         } else {
//           return { name, order: "desc", step: 0 }; // حالت سوم: تاریخ ایجاد نزولی
//         }
//       } else {
//         // اگر ستون جدیدی انتخاب شد
//         return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
//       }
//     });
//     setreload(!reload);
//   };

//   const handleSelect = (value: number) => {
//     setSelectedNumber(value); // ذخیره مقدار انتخابی
//     const newSize = value;
//     let newPage = currentPage;

//     const totalItems = alldata ? Number(alldata) : 0;

//     if (newPage > Math.ceil(totalItems / newSize)) {
//       newPage = Math.max(1, Math.ceil(totalItems / newSize));
//     }
//     setsize(newSize); // تنظیم سایز جدید
//     setCurrentPage(newPage); // تنظیم صفحه جدید
//     // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
//     // fetchData(currentPage, selectedNumber);
//   };

//   useEffect(() => {
//     setreload(!reload);
//   }, []);

//   const handlersettlement = async (data: any) => {
//     const {
//       one_percent_deduction = 0,
//       pure_payable = 0,
//       remaining_receivable_payable_balance = 0,
//       total_farmers_price = 0,
//       total_guarantee_price = 0,
//       total_pesticide_cost = 0,
//       total_seed_cost = 0,
//       total_weight = 0,
//       farmer_id,
//     } = data;

//     // Check if all values are zero
//     const allZero = [
//       one_percent_deduction,
//       pure_payable,
//       remaining_receivable_payable_balance,
//       total_farmers_price,
//       total_guarantee_price,
//       total_pesticide_cost,
//       total_seed_cost,
//       total_weight,
//     ].every((value) => value === 0);

//     if (allZero) {
//       Swal.fire({
//         title: "خطا",
//         text: "هیچ موردی برای این کشاورز ثبت نشده است و امکان تسویه حساب وجود ندارد.",
//         icon: "error",
//         confirmButtonText: "متوجه شدم",
//       });
//       return;
//     }
//     if (
//       remaining_receivable_payable_balance < 0 ||
//       total_guarantee_price < 0 ||
//       total_weight <= 0
//     ) {
//       let errorMessage = "";

//       if (remaining_receivable_payable_balance < 0) {
//         errorMessage += "مانده طلب یا بدهی نمی‌تواند منفی باشد. ";
//       }

//       if (total_guarantee_price < 0) {
//         errorMessage += "مبلغ ضمانت نمی‌تواند منفی باشد. ";
//       }

//       if (total_weight <= 0) {
//         errorMessage += "وزن باید بزرگتر از صفر باشد. ";
//       }

//       Swal.fire({
//         title: "خطا",
//         text: "به علت صفر نبودن مانده طلب یا بدهی ضمانت، امکان تسویه حساب این کشاورز وجود ندارد.",
//         icon: "error",
//         confirmButtonText: "متوجه شدم",
//       });
//       return false;
//     } else {
//       try {
//         const result = await Swal.fire({
//           title: "تأیید تسویه حساب",
//           text: "آیا از تسویه حساب این کشاورز و ارسال پیامک برای او مطمئن هستید؟",
//           icon: "question",
//           showCancelButton: true,
//           confirmButtonText: "بله",
//           cancelButtonText: "خیر",
//           reverseButtons: true,
//         });

//         if (result.isConfirmed) {
//           const yearID = localStorage.getItem("crop_year_id");
//           const res = await axios.post(
//             "https://api.havirkesht.ir/farmers_invoice/payment",
//             {
//               farmer_id: farmer_id,
//               crop_year_id: yearID,
//               payed: true,
//             },
//             {
//               headers: {
//                 Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
//               },
//             }
//           );

//           if (res.status === 200) {
//             // فراخوانی دوم برای ارسال پیامک
//             await axios.post(
//               `https://api.havirkesht.ir/sms/farmer-invoice-notification/${farmer_id}/${yearID}`,
//               {},
//               {
//                 headers: {
//                   Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
//                 },
//               }
//             );

//             Swal.fire({
//               title: "موفقیت آمیز",
//               text: "تسویه حساب این کشاورز با موفقیت انجام شد.",
//               icon: "success",
//               confirmButtonText: "متوجه شدم",
//             });
//             fetchData(currentPage, selectedNumber);
//             resetSorting();
//           }
//         }
//       } catch (error: any) {
//         console.error("Error in settlement:", error);

//         Swal.fire({
//           title: "خطا",
//           text:
//             error.response?.status === 400
//               ? "درخواست نامعتبر (کد 400)"
//               : "مشکلی در انجام تسویه حساب رخ داده است.",
//           icon: "error",
//           confirmButtonText: "متوجه شدم",
//         });
//       }
//     }
//   };
//   const pdfRenderInvoice = async (farmerID: any) => {
//     setloadingModalPDF(true);
//     fetchReport(farmerID);
//   };
//   const columns = InvoiceColumn({
//     columnName,
//     handlersettlement,
//     pdfRenderInvoice,
//   });

//   const resetSorting = () => {
//     setSortState({
//       name: null,
//       order: "desc",
//       step: 0,
//     });
//     setreload(!reload);
//   };
//   if (loadingModalPDF)
//     return (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//         <div className="bg-white p-6 rounded-lg shadow-xl flex flex-col items-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mb-4"></div>
//           <p className="text-gray-700">
//             در حال آماده‌سازی فایل PDF، لطفاً صبر کنید...
//           </p>
//         </div>
//       </div>
//     );
// return (
//   <React.Fragment>
//     <BreadCrumb pageTitle="مدیریت پرداخت‌ها" title="پنل مدیریت" />
//     <div className="card" id="paymentTable">
//       <div className="card-body">
//         <div className="flex flex-col md:flex-row gap-3 mb-4 items-center">
//           <h6 className="text-15 grow md:text-right text-center">
//             تعداد کل : <b>{totalItems}</b>
//             <br />
//             <span>{`سال زراعی انتخاب شده ${YearCoptSelect ? YearCoptSelect : ""
//               }`}</span>
//             <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
//               <span className="whitespace-nowrap p-1">جستجو:</span>
//               <div className="relative w-full sm:w-64">
//                 <input
//                   type="text"
//                   className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
//                   placeholder="جستجو..."
//                   value={searchQuery || ""}
//                   onChange={(e) => {
//                     setSearchQuery(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />


//                 <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
//                   {searchQuery ? (
//                     <X
//                       size={15}
//                       className="cursor-pointer"
//                       onClick={() => setSearchQuery("")}
//                     />
//                   ) : (
//                     <SearchIcon size={15} />
//                   )}
//                 </span>
//               </div>
//               <div className="w-full sm:w-auto">
//                 <TableDropDownSmall onSelect={handleSelect} />
//               </div>
//             </label>
//           </h6>
//           <div className="flex md:flex-row flex-col flex-wrap gap-4 p-4  dark:text-white">
//             <div className="bg-white p-4 rounded-lg    shadow  dark:bg-gray-600  dark:text-white">
//               <div className="text-gray-500 text-sm  dark:bg-gray-600 dark:text-white">
//                 جمع طلب کشاورز
//               </div>

//               <div className="text-red-500 rtl font-bold  dark:bg-gray-600 dark:text-white mt-1">
//                 {total_farmers_receivable?.toLocaleString("fa-IR", {
//                   maximumFractionDigits: 0,
//                   minimumFractionDigits: 0,
//                 })}{" "}
//               </div>
//             </div>

//             <div className="bg-white p-4 rounded-lg    shadow  dark:bg-gray-600  dark:text-white">
//               <div className="text-gray-500 text-sm  dark:bg-gray-600 dark:text-white">
//                 وزن کل چغندر تحویلی
//               </div>
//               <div className="text-green-600 font-bold  dark:bg-gray-600 dark:text-white mt-1">
//                 {total_delivered_beet_weight?.toLocaleString("FA-IR")}
//               </div>
//             </div>

//             <div className="bg-white p-4 rounded-lg   shadow  dark:bg-gray-600 dark:text-white">
//               <div className="text-gray-500 text-sm  dark:bg-gray-600 dark:text-white">
//                 مبلغ کل بارها
//               </div>
//               <div className="text-blue-600 font-bold  dark:bg-gray-600 dark:text-white mt-1">
//                 {total_load_price
//                   ?.toLocaleString("FA-IR")
//                   .toLocaleString("fa-IR", {
//                     maximumFractionDigits: 0,
//                     minimumFractionDigits: 0,
//                   })}{" "}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className=""></div>
//         {sortState.name && (
//           <div className="gap-1 mb-2 items-center flex">
//             <X
//               size={16}
//               className="text-red-600 cursor-pointer"
//               onClick={resetSorting}
//             />
//             مرتب‌سازی بر اساس:{" "}
//             {sortState.step === 2
//               ? ` (تاریخ ایجاد)`
//               : `${sortLabels[sortState.name]} ${sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
//               }`}
//           </div>
//         )}
//         {data && data.length > 0 ? (
//           <TableContainer
//             isPagination={false}
//             columns={columns}
//             isGlobalFilter={false}
//             customnumberfortable={8}
//             data={data}
//             TableFarmerInvoise={true}
//             customPageSize={selectedNumber}
//             divclassName="-mx-5 overflow-x-auto"
//             tableclassName="w-full whitespace-nowrap"
//             theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
//             thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
//             tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
//           />
//         ) : (
//           <LoadingCounter
//             count={isLoading ? 10 : 0}
//             text={isLoading ? "در حال بارگذاری..." : "داده ای دریافت نشد"}
//           />
//         )}
//         <PaginationTest
//           currentPage={currentPage}
//           totalPages={totalPages}
//           onPageChange={handlePageChange}
//         />
//       </div>
//     </div>
//     <InvoiceWithInput
//       dataSeed={DataSeed}
//       userInfo={UserFullName}
//       exportPdfFromProp={exportPdf}
//       userinfoData={userinfoAllData}
//       dataLoad={LoadFarmer}
//       dataPayment={pamentFarmerr}
//       dataPoison={Dataesticide}
//       reportData={reportData}
//       dontShowData={true}
//     />
//     {/* مودال ثبت پرداخت جدید */}
//   </React.Fragment>
// );
// };

// export default InvoiceFarmer;
